import * as api from '~services/api';

export const getMatters = () => api.get('data/infoservice/matters');

export const getGroups = () => api.get('data/infoservice/groups');
